import React from "react";
import Navbar from "../components/Navbar";
import Oteatrze from "../components/oteatrze";
import Aktualnosci from "../components/aktualnosci";
import Repertuar from "../components/repertuar";
import Stopka from "../components/stopka";
import Spetakle from "../components/spetakle";
import Naszteatr from "../components/naszteatr";
import Aktualnosci2 from "../components/aktualnosci2";
import AktualnosciMini from "../components/aktualnoscimini";

function Home() {
  return (
    <div>
      <Navbar/>
      <div className="pt-24">
        <section id="oteatrze" className="pt-24 -mt-24">
          <Oteatrze/>
        </section>
        <section id="repertuar" className="pt-24 -mt-24">
          <Repertuar />
        </section>
        <section id="aktualnosci" className="pt-24 -mt-24">
          <AktualnosciMini/>
        </section>
        <section id="spetakle" className="pt-24 -mt-24">
          <Spetakle />
        </section>
        <section id="warsztaty" className="pt-24 -mt-24">
          <Naszteatr />
        </section>
        <Stopka/>
      </div>
    </div>
  );
}

export default Home;
